export class ManipulationCodes {
    static readonly unloadingVessel = 'VSIN';
    static readonly loadingVessel = 'VSOUT';
    static readonly unloadingVesselDirect = 'DVSIN';
    static readonly loadingVesselDirect = 'DVSOUT';
    static readonly RLIN = 'RLIN';
    static readonly RLOUT = 'RLOUT';
    static readonly TRIN = 'TRIN';
    static readonly TROUT = 'TROUT';
    static readonly TRVS = 'TR-VS';
    static readonly RLVS = 'RL-VS';
    static readonly VSTR = 'VS-TR';
    static readonly VSRL = 'VS-RL';
    static readonly VSVS = 'VS-VS';
    static readonly ADDS = 'ADDS';
    static readonly FCFS = 'FCFS';
    static readonly TCFS = 'TCFS';
    static readonly VS = 'VS';
    static readonly VSBLT = 'VS-BLT';
    static readonly BLTVS = 'BLT-VS';

    static readonly vesselInManipulations = [
        ManipulationCodes.unloadingVessel,
        ManipulationCodes.VSRL,
        ManipulationCodes.VSTR,
        ManipulationCodes.VSVS
    ];

    static readonly unloadVesselConveyorBeltManipulations = [
        ManipulationCodes.unloadingVessel,
        ManipulationCodes.VSBLT
    ];

    static readonly loadVesselConveyorBeltManipulations = [ManipulationCodes.loadingVessel, ManipulationCodes.BLTVS];

    static readonly exitMotManipulations = [ManipulationCodes.TROUT, ManipulationCodes.RLOUT];

    static readonly unloadingManipulations = [
        ManipulationCodes.TRIN,
        ManipulationCodes.RLIN,
        ManipulationCodes.TRVS,
        ManipulationCodes.RLVS,
        ManipulationCodes.FCFS
    ];

    static readonly loadingManipulations = [
        ManipulationCodes.TROUT,
        ManipulationCodes.RLOUT,
        ManipulationCodes.VSTR,
        ManipulationCodes.VSRL,
        ManipulationCodes.TCFS
    ];

    static readonly vesselVisitManipulations = [
        ManipulationCodes.unloadingVessel,
        ManipulationCodes.VSTR,
        ManipulationCodes.VSRL,
        ManipulationCodes.VSVS,
        ManipulationCodes.VSBLT,
        ManipulationCodes.BLTVS,
        ManipulationCodes.RLVS,
        ManipulationCodes.TRVS,
        ManipulationCodes.loadingVessel,
        ManipulationCodes.RLOUT,
        ManipulationCodes.TROUT
    ];

    static readonly motTabExcludedManipulations = [
        ManipulationCodes.unloadingVessel,
        ManipulationCodes.loadingVessel,
        ManipulationCodes.VSVS,
        ManipulationCodes.VSBLT,
        ManipulationCodes.BLTVS
    ];
}
